export { Hotkey, parseHotkeys } from './Hotkey';
